function withFragments(query, ...fragments) {
  return {
    ...query,
    definitions: [...query.definitions, ...fragments]
  }
}

function getGraphQLQuery(q) {
  if (!q) throw new Error('No apollo query provided.')
  return {
    query: typeof q.query === 'function' ? q.query.apply(this) : q.query,
    variables: typeof q.variables === 'function' ? q.variables.apply(this) : q.variables
  }
}

export default {
  install(Vue) {
    Vue.prototype.$withFragments = withFragments
    Vue.prototype.$getGraphQLQuery = getGraphQLQuery
  }
}
